<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        block
        v-on="on"
      >
        Create
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Payroll Banks"
      text="Create payroll bank"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="dialog && !loading">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="shiftCode"
                v-validate="'required'"
                :error-messages="errors.collect('shiftCode')"
                data-vv-name="shiftCode"                
                data-vv-as="swift code"                
                label="Swift Code"
                outlined
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="bankCode"
                label="Bank Code"
                outlined
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"         
          @click="submitForm"
        >
          Save
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        loading: false,
        dialog: false,        
        progressing: false,       
        name: null,
        shiftCode: null,
        bankCode: null,
      }
    },
    watch: {
      dialog (value) {
        if (!value) return       
        this.$validator.reset() 
        this.name = null
        this.shiftCode = null
        this.bankCode = null
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true

            this.$api.payrollBanks().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {      
                  this.$emit('created', res.data)                
                  this.progressing = false
                  this.dialog = false
                }
              })
          })
      },   
   
      prepareFormData () {
        return {
          name: this.name,
          shift_code: this.shiftCode,
          bank_code: this.bankCode,
        }
      },
    },
  }
</script>
